export default "__VITE_ASSET__f18d8c1c__"